import { getEnumText, valueModifies } from '@/utils/index'
import { convertToRules } from '@/utils/validate'
import { getData } from '@/utils/dataSync'
import { getPropByPath } from 'element-ui/src/utils/util'
import { checkEnumFlag } from '@/utils/validate'
let numeral = require('numeral')
import _ from 'lodash'
export default {
  props: {
    validate: {
      type: String,
      default: null,
    },
    dataType: {
      type: String,
      default: 'local',
    },
    dataKey: {
      type: String,
      default: 'divisionList',
    },
    dataItems: {
      type: Array,
      default: null,
    },
    requestParam: {
      type: Object,
      default: () => ({}),
    },
    labelClass: {
      type: String,
      default: '',
    },
    valueId: {
      type: [String, Number],
      default: 'value',
    },
    labelId: {
      type: [String, Number],
      default: 'text',
    },
    filter: {
      type: [String, Object],
      default: null,
    },
    sortBy: {
      type: String,
      default: null,
    },
    enableCache: {
      type: Boolean,
      default: false,
    },
    resultType: {
      type: String,
      default: 'Array',
    },
    startDateProp: {
      type: String,
      default: null,
    },
    endDateProp: {
      type: String,
      default: null,
    },
    enableSameDate: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    labelShow: {
      type: Boolean,
      default: true,
    },
    nullable: {
      type: Boolean,
      default: false,
    },
    codeEnum: {
      type: Object,
      default: null,
    },
    modelModifiers: {
      type: Object,
      default: () => ({}),
    },
    selectValue: {
      type: [String, Number],
    },
    directive: {
      type: Boolean,
      default: false,
    },
    showAfter: {
      type: String,
      default: null,
    },
    textEllipsis: {
      type: Boolean,
      default: false,
    },
    unForm: {
      type: Boolean,
      default: false,
    },
    workYmDate: {
      type: [String, Number],
      default: null,
    },
    defaultValue: {
      type: Date,
      default: () => {
        return new Date()
      },
    },
    valueFormatSss: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //画面のFROMを取得する
    form() {
      let parent = this.$parent
      let parentName = parent.$options.componentName
      while (parentName !== 'ElForm') {
        parent = parent.$parent
        parentName = parent.$options.componentName
      }
      return parent
    },
    //非活性の設置
    disabled() {
      if (this.localDisabled) {
        return true
      }

      if (_.has(this.$attrs, 'disabled')) {
        if (
          _.get(this.$attrs, 'disabled') === true ||
          _.get(this.$attrs, 'disabled') === ''
        ) {
          return true
        }
      }
      return false
    },
  },
  data() {
    return {
      innerValue: null,
      innerValues: [],
      dataSource: [],
      type: null,
      trigger: 'blur',
      localDisabled: false,
    }
  },
  watch: {
    'form.model': {
      handler(newVal) {
        if (this.$attrs.prop) {
          this.createModel()
          let val = _.get(newVal, this.$attrs.prop)
          if (Array.isArray(val)) {
            if (
              this.$baseLodash.isEmpty(
                this.$baseLodash.difference(val, this.innerValues)
              )
            ) {
              return
            }
            this.innerValues = val
          } else {
            if (this.$attrs['min'] && !val) {
              val = this.$attrs['min']
            }

            //フォーマットがある場合、numeralをフォーマットする
            if (this.$attrs.type == 'number') {
              this.className = 'number'
              let format = this.$attrs.format ?? '0,0'
              // if (Number(val) != 0) {

              // }
              if (val != null) {
                let zero = this.$attrs.zero ?? true
                if (zero) {
                  val = numeral(val).format(format)
                } else {
                  val = val.toString()
                }
              }
            }
            if (this.$attrs.format == 'enum') {
              val = getEnumText(val, this.codeEnum)
            }
            if (this.type == 'boolean') {
              val = checkEnumFlag(val)
            }

            if (this.type == 'time') {
              val = this.formatTimeMsel(val, 'HH:mm')
            }
            if (this.type == 'dayTime') {
              val = this.formatDayTime(val)
            }

            if (this.innerValue === val) {
              return
            }
            this.innerValue = val
          }
        }
      },
      deep: true,
      immediate: true,
    },
    dataItems: {
      handler(newVal) {
        this.fillList(newVal)
      },
    },
  },
  beforeMount() {
    let vm = this
    if (this.validate) {
      let prop = this.$attrs.prop
      let label = this.$attrs.label
      let labelError = this.$attrs['label-error']
      let type = this.type

      if (this.form.rules) {
        let rules = _.concat(
          this.form.rules[prop] || [],
          convertToRules(this.validate, label || labelError, type, vm.trigger)
        )
        this.$set(this.form.rules, prop, rules)
      }
    }
  },
  mounted() {
    let type = this.$route?.query.type
    if (type == 'view') {
      this.localDisabled = true
    }
  },
  created() {
    this.$baseEventBus.$on('ComponentReset', this.handleFieldReset)
    this.$on('fieldReset', this.handleFieldReset)
  },
  methods: {
    fetchData() {
      if (this.dataItems) {
        this.dataSource = this.dataItems || []
        this.fillList(this.dataSource)
      } else {
        var promise = getData({
          enableCache: this.enableCache,
          key: this.dataKey,
          dataType: this.dataType,
          requestParam: this.requestParam,
        }).then((res) => {
          let list = null
          if (_.has(res, 'list')) {
            list = res.list
          } else {
            list = res
          }
          if (_.isString(this.filter)) {
            list = _.get(list, this.filter)
          }
          if (_.isObject(this.filter)) {
            list = _.filter(list, this.filter)
          }
          if (list) {
            this.dataSource = list
            this.fillList(list)
          }

          return list
        })
        //promiseをページコンポネントインスタンスに反映する
        if (this.pageComponent) {
          this.pageComponent.registerPromise(promise)
        }
      }
    },
    fillList(list) {
      if (this.labelList) {
        list.forEach((res) => {
          this.labelList.push(res[this.labelId])
          this.labelMap[res[this.labelId]] = res[this.valueId]
          this.valueMap[res[this.valueId]] = res[this.labelId]
        })
      }
    },
    createModel() {
      if (this.$attrs.prop && !_.has(this.form.model, this.$attrs.prop)) {
        let model = { ...this.form.model }
        _.set(model, this.$attrs.prop, null)
        let prop = this.$attrs.prop.split('.')[0]
        this.$set(this.form.model, prop, model[prop])
      }
    },
    setModel(value) {
      if (this.form && this.$attrs.prop) {
        let prop = getPropByPath(this.form.model, this.$attrs.prop, true)
        if (this.$attrs.type == 'number') {
          if (value) {
            value = value.replace(/\D/g, '')
            value = numeral(value).value()
          }
        }
        let tmpModifiers = this.modelModifiers
        if (this.type == 'boolean') {
          tmpModifiers['boolean'] = true
        }

        //prop.o[prop.k] = valueModifies(tmpModifiers, value)
        this.$set(prop.o, prop.k, valueModifies(tmpModifiers, value))
        // const ob = prop.o.__ob__
        // if (ob) {
        //   ob.dep.notify()
        // }
      }
      this.$emit('change', value)
    },
    handleChange(val) {
      if (this.$attrs.prop) {
        this.setModel(val)
      } else {
        //this.innerValue = val
        this.$emit('change', val)
      }
      this.$emit('update:selectValue', val)
    },
    handleFocus(value) {
      this.$emit('focus', value)
      this.$emit('update:selectValue', value)
    },
    handleBlur(val) {
      if (this.$attrs.type == 'number') {
        let val = this.innerValue || ''
        val = val.replace(/\D/g, '')
        let format = this.$attrs.format ?? '0,0'
        let zero = this.$attrs.zero ?? true
        if (zero) {
          this.innerValue = this.numeral(val).format(format)
        } else {
          this.innerValue = val.replace(/^0/g, '')
        }
        if (this.$attrs.maxlength) {
          //substring
          if (
            this.innerValue &&
            this.innerValue.length > this.$attrs.maxlength
          ) {
            this.innerValue = _.trim(
              this.innerValue.slice(0, this.$attrs.maxlength),
              ','
            )
            this.setModel(this.innerValue)
          }
        }
      }
      this.$emit('blur', val)
    },
    handleFieldReset() {
      if (!this.localDisabled) {
        this.innerValue = null
        this.innerValues = null
        this.setModel(null)
      }
    },
  },
}
